import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {ErrorLevel} from '../shared/contracts/errors.interface';
import {NotificationService} from '../shared/services/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private readonly errorMessages: Record<string, string> = {
    ITEM_NOT_FOUND: 'Elemento con questo ID non trovato.',

    USER_NOT_FOUND: 'Nessun utente trovato.',
    USER_UNAUTHORIZED: 'I Dati inseriti non sono corretti.',
    LIMIT_FOR_USERS_REACHED: 'Non puoi creare altri utenti per questa azienda.',

    ALREADY_OPEN: 'Conversazione già aperta e in gestione o attiva e pronta per essere assegnata',
    SESSION_EXPIRED: 'Sessione scaduta. Per favore invia un messaggio di template',
  };

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const code = error.error?.detail?.code;
        let message = this.errorMessages[code];
        if (message) {
          this.processNotificationByLevel(error.error.detail.level, message);
        } else {
          message = 'Si è verificato un errore imprevisto.'
          this.processNotificationByLevel(ErrorLevel.ERROR, message);
        }

        return throwError(() => error);
      })
    );
  }

  private processNotificationByLevel(level: ErrorLevel, message: string) {
    switch (level) {
      case ErrorLevel.ERROR:
        this.notificationService.error(message);
        break;
      case ErrorLevel.WARNING:
        this.notificationService.warning(message);
    }
  }

  constructor(private notificationService: NotificationService) {
  }
}
